module.exports = __webpack_public_path__ + "static/media/collaborationEU-EN.a1f9d62e.png";